import type { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components/macro';

const MessagesLoader: FC = () => {
  const theme = useTheme();

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={374}
      backgroundColor={theme.colors.surface}
      foregroundColor={theme.colors.primary.variant6}
    >
      <rect x="0" y="0" rx="50%" ry="50%" width="32" height="32" />
      <rect x="38" y="4" rx="2" ry="2" width="60%" height="8" />
      <rect x="38" y="20" rx="2" ry="2" width="50%" height="8" />

      <rect x="0" y="62" rx="50%" ry="50%" width="32" height="32" />
      <rect x="38" y="66" rx="2" ry="2" width="60%" height="8" />
      <rect x="38" y="82" rx="2" ry="2" width="50%" height="8" />

      <rect x="0" y="124" rx="50%" ry="50%" width="32" height="32" />
      <rect x="38" y="128" rx="2" ry="2" width="60%" height="8" />
      <rect x="38" y="144" rx="2" ry="2" width="50%" height="8" />

      <rect x="0" y="186" rx="50%" ry="50%" width="32" height="32" />
      <rect x="38" y="190" rx="2" ry="2" width="60%" height="8" />
      <rect x="38" y="206" rx="2" ry="2" width="50%" height="8" />

      <rect x="0" y="248" rx="50%" ry="50%" width="32" height="32" />
      <rect x="38" y="252" rx="2" ry="2" width="60%" height="8" />
      <rect x="38" y="268" rx="2" ry="2" width="50%" height="8" />

      <rect x="0" y="310" rx="50%" ry="50%" width="32" height="32" />
      <rect x="38" y="314" rx="2" ry="2" width="60%" height="8" />
      <rect x="38" y="330" rx="2" ry="2" width="50%" height="8" />
    </ContentLoader>
  );
};

export default MessagesLoader;
